module.exports = __webpack_public_path__ + "static/img/rank_308.14f65a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_308.png
// module id = 5tuj
// module chunks = 0